<template>
  <div id="tramiteNuevo">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Trámite / Notifica
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-card class="elevation-0">
        <v-card-title class="lighten-3">
          <span class=""><b>Tipo de Trámites:</b> {{ tramites }}</span>
        </v-card-title>
      </v-card>
      <br>
      <v-card>
        <v-card-title class="headline  lighten-3">
          <span class="headline">Notificación</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form_notifica">
            <v-layout row wrap>
              <v-flex xs12 class="my-0">
                <v-textarea
                  label="Observación"
                  v-model="observacion"
                  :rules="[v => !!v || 'El campo es requerido']"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 class="my-0">
                <v-switch
                  v-model="subsanable"
                  :label="'¿Es subsanable?: ' +(subsanable==true?'Si':'No')"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="confirmTramite">
            Guardar
          </v-btn>
          <v-btn color="red" dark @click="waitTramite">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="cdialog" persistent max-width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center">
          <span :class="color_txt + '--text text--darken-2 subheading'">
            {{ mensaje }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingBtnSend" v-if="hide_accept && type_action" color="success darken-1" flat @click.native="sendTramite">
            Aceptar
          </v-btn>
          <v-btn :loading="loadingBtnSend" v-if="!type_action" color="success darken-1" flat @click.native="redirect">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="closeDialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2800"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "filtro-departamental",
  data: () => ({
    headers: [
      { text: 'Nro', align: 'left', sortable: false, width: '6%' },
      { text: 'Requisitos ', sortable: false, width: '46%' },
      { text: 'Si', sortable: false, width: '6%' },
      { text: 'No', sortable: false, width: '6%' },
      { text: 'Observaciones', sortable: false, width: '36%' }
    ],
    loading: false,
    loadingBtnSend: false,
    cdialog: false,
    hide_accept: false,
    color_txt: '',
    mensaje: '',
    dparams: {},
    subsanable: true,
    observacion: '',
    tipo_tramite:[],
    requisitos: [],
    tramites: '',
    type_action: false,
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 3000,
      text: ""
    }
  }),
  created() {
    if (Service.getTramiteId() == null) {
      this.$router.push('/tramite/recibido');
    }
  },
  mounted() {
    this.dparams = Service.getParams();
    this.getDatos();
    
  },
  methods: {
    getDatos() {
      axios
        .get(Service.getBase() + "tramite/tarea/3/" + Service.getTramiteId(), Service.getHeader())
        .then(response => {
          if (response.data.datos !='') {
            let datos = JSON.parse(response.data.datos);
            this.dparams.ie_id = datos.institucioneducativa_id;
            this.observacion = datos.observacion;
            this.tipo_tramite = datos.tipo_tramite;
            var cantidad_tramites = (datos.tipo_tramite.length-1);
            for (var key in datos.tipo_tramite) {
              let tramite_nombre = '';
              switch (datos.tipo_tramite[key]) {
                case 2:
                  tramite_nombre = 'Ratificación';
                  break;
                case 3:
                  tramite_nombre = 'Ampliación';
                  break;
                case 4:
                  tramite_nombre = 'Cambio de Razón Social';
                  break;
                case 5:
                  tramite_nombre = 'Cambio de Domicilio';
                  break;
                case 6:
                  tramite_nombre = 'Cambio de derecho Propietario';
                  break;
                default:
                  tramite_nombre = 'Apertura';
                  break;
              }
              this.tramites += tramite_nombre+(key < cantidad_tramites?', ':'');
            }
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    confirmTramite() {
      this.color_txt = 'grey';
      this.mensaje = '¿Esta seguro(a) de enviar la observación o finalizar el trámite con la información ingresada?';
      this.loadingBtnSend = false;
      this.hide_accept = true;
      this.type_action = true;
      if (this.$refs.form_notifica.validate()) {
        this.cdialog = true;
      }
    },
    sendTramite() {
      this.loadingBtnSend = true;
      this.dparams.tipo_tramite = this.tipo_tramite;
      //this.dparams.institucioneducativa_id = this.tipo_tramite;
      this.dparams.tramite_id = Service.getTramiteId();
      // var fd = new FormData();
      // fd.append('params', JSON.stringify(this.dparams));
      // fd.append('subsanable', this.subsanable);
      // fd.append('observacion', this.observacion);
      axios
        .post(Service.getBase() + 'notifica/departamental', {'params': JSON.stringify(this.dparams),'subsanable': this.subsanable,'observacion': this.observacion}, Service.getHeader())
        .then(response => {
          this.loadingBtnSend = false;
          if (response.data.estado == 200) {
            this.color_txt = 'success';
            this.$refs.form_notifica.reset();
            this.subsanable = false;
            this.hide_accept = false;
            // localStorage.removeItem("itr");
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.mensaje = response.data.msg;
        })
        .catch(error => {
          this.loadingBtnSend = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.mensaje = "No se pudo registrar el trámite";
          console.error("Error al guardar", error);
        });
    },
    closeDialog() {
      if (this.hide_accept == false) {
        // localStorage.removeItem("itr");
        this.$router.push({name: 'tramite/recibido'});
      }
      this.cdialog = false;
    },
    waitTramite() {
      this.color_txt = 'grey';
      this.mensaje = '¿Está segura(o) de posponer el trámite? Puede retomar el trámite en la bandeja de recibidos.';
      this.hide_accept = true;
      this.type_action = false;
      this.cdialog = true;
    },
    redirect() {
      this.$router.push({name: 'tramite/recibido'});
    },   
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>